module.exports = __webpack_public_path__ + "img/Smiley.79029cf8.svg";